import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

// A multi select input to select multiple tags
function Tags({ field, getValues }) {
  const [tagOptions, setTagOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  async function fetchTags() {
    if (!getValues('domains')) {
      return;
    }
    setIsLoading(true);
    try {
      let group_ids = [];
      let location_ids = [];
      // getValues("domains") is the current selectedNodes of the DomainSelect component
      getValues('domains').forEach((item) => {
        if (item.className.includes('filter-group')) {
          group_ids.push(item.value);
        } else if (item.className.includes('filter-location')) {
          location_ids.push(item.value);
        }
      });

      const res = await fetch(`/reports/tags`, {
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name=csrf-token]').content,
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
          group_ids,
          location_ids,
          show_inactive: getValues('show_inactive'),
        }),
      });
      const data = await res.json();

      const options = data.map((tag) => ({
        value: tag.tag_id,
        label: `${tag.tag_group_name} - ${tag.tag_name}`,
      }));
      setTagOptions(options);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Select
      {...field}
      id='tag_ids'
      name='tag_ids'
      placeholder='Select Tags'
      isMulti
      isLoading={isLoading}
      options={tagOptions}
      onFocus={fetchTags}
    />
  );
}

Tags.propTypes = {
  field: PropTypes.object.isRequired,
  getValues: PropTypes.func.isRequired,
};

export default Tags;
